// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-HrisManager-styles___hrisManagerContainer--vy_iy {
  margin: 16px;
  padding: 16px;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___header--IEt5K {
    padding: 8px 16px;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___supportText--qHiys {
    margin: 0 0 16px 0;
    padding: 0 16px;
    color: #666;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___createButton--vKXvX {
    margin: 20px 0;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___infoLoader--azcX4 {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___table--zgUgq {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___headerCell--QFIXJ {
    background-color: #f5f5f5;
    font-weight: bold;
    padding: 10px;
    border: 1px solid #ddd;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___cell--qTwjE {
    padding: 10px;
    border: 1px solid #ddd;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___row--ru03p:hover {
    background-color: #f1f1f1;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___disabledButton--f6Jkt {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___enabledButton--xT1ly {
    background-color: #3f51b5;
    color: white;
  }

  .components-HrisManager-styles___hrisManagerContainer--vy_iy .components-HrisManager-styles___actionButton--t4pFi {
    margin-left: 10px;
  }`, "",{"version":3,"sources":["webpack://./components/HrisManager/styles.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AA6D1C;;EA3DE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EACA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;IACN,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".hrisManagerContainer {\n  margin: 16px;\n  padding: 16px;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .header {\n    padding: 8px 16px;\n  }\n\n  .supportText {\n    margin: 0 0 16px 0;\n    padding: 0 16px;\n    color: #666;\n  }\n  .createButton {\n    margin: 20px 0;\n  }\n\n  .infoLoader {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    right: 0;\n  }\n\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n\n  .headerCell {\n    background-color: #f5f5f5;\n    font-weight: bold;\n    padding: 10px;\n    border: 1px solid #ddd;\n  }\n\n  .cell {\n    padding: 10px;\n    border: 1px solid #ddd;\n  }\n\n  .row:hover {\n    background-color: #f1f1f1;\n  }\n\n  .disabledButton {\n    background-color: #ccc;\n    cursor: not-allowed;\n  }\n\n  .enabledButton {\n    background-color: #3f51b5;\n    color: white;\n  }\n\n  .actionButton {\n    margin-left: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hrisManagerContainer": `components-HrisManager-styles___hrisManagerContainer--vy_iy`,
	"header": `components-HrisManager-styles___header--IEt5K`,
	"supportText": `components-HrisManager-styles___supportText--qHiys`,
	"createButton": `components-HrisManager-styles___createButton--vKXvX`,
	"infoLoader": `components-HrisManager-styles___infoLoader--azcX4`,
	"table": `components-HrisManager-styles___table--zgUgq`,
	"headerCell": `components-HrisManager-styles___headerCell--QFIXJ`,
	"cell": `components-HrisManager-styles___cell--qTwjE`,
	"row": `components-HrisManager-styles___row--ru03p`,
	"disabledButton": `components-HrisManager-styles___disabledButton--f6Jkt`,
	"enabledButton": `components-HrisManager-styles___enabledButton--xT1ly`,
	"actionButton": `components-HrisManager-styles___actionButton--t4pFi`
};
module.exports = ___CSS_LOADER_EXPORT___;
